import React from 'react';
import {
  isPriceOptionDisabled,
  getPriceButtonText,
} from '../../utils/formOptions';
import {
  buildMinPriceOptions,
  buildMaxPriceOptions,
} from '../../utils/priceOptionsUtils';

function PriceRangeDropdown({
  maxPriceData,
  minPrice,
  maxPrice,
  onMinPriceChange,
  onMaxPriceChange,
  isOpen,
  onToggle,
}) {
  const minPriceOptions = buildMinPriceOptions(maxPriceData);
  const maxPriceOptions = buildMaxPriceOptions(maxPriceData);

  const getButtonText = () => getPriceButtonText(minPrice, maxPrice);

  return (
    <fieldset className="md:border-l-2 bg-white h-15 border-[#ebebeb] lg:h-full md:bg-none flex items-center justify-center relative">
      <legend className="sr-only">Price range</legend>
      <button
        type="button"
        className="text-sm font-medium flex items-center gap-3 lg:h-15"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        {getButtonText()}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          aria-hidden="true"
          focusable="false"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        >
          <use href="#icon-chevron-down" />
        </svg>
      </button>
      {isOpen && (
        <div className="z-50 absolute w-full xl:w-[calc(100%+4px)] bg-white top-full -left-[2px] p-4 border-2 border-[#ebebeb]">
          <div className="mb-4">
            <label
              className="block font-light text-xs mb-2"
              htmlFor="min-price"
            >
              Minimum price
            </label>
            <div className="relative">
              <select
                id="min-price"
                className="px-3 min-h-[42px] bg-grey-100 w-full border border-[#ebebeb] appearance-none"
                name="min-price"
                value={minPrice}
                onChange={(e) => onMinPriceChange(e.target.value)}
              >
                {minPriceOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={
                      option.value &&
                      isPriceOptionDisabled(
                        option.value,
                        'min',
                        minPrice,
                        maxPrice
                      )
                    }
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
                aria-hidden="true"
                focusable="false"
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
              >
                <use href="#icon-chevron-down" />
              </svg>
            </div>
          </div>
          <div>
            <label
              className="block font-light text-xs mb-2"
              htmlFor="max-price"
            >
              Maximum price
            </label>
            <div className="relative">
              <select
                id="max-price"
                className="px-3 min-h-[42px] bg-grey-100 w-full border border-[#ebebeb] appearance-none"
                name="max-price"
                value={maxPrice}
                onChange={(e) => onMaxPriceChange(e.target.value)}
              >
                {maxPriceOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={
                      option.value &&
                      isPriceOptionDisabled(
                        option.value,
                        'max',
                        minPrice,
                        maxPrice
                      )
                    }
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
                aria-hidden="true"
                focusable="false"
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
              >
                <use href="#icon-chevron-down" />
              </svg>
            </div>
          </div>
        </div>
      )}
    </fieldset>
  );
}

export default PriceRangeDropdown;
